"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _GeometryRestriction_raycaster, _GeometryRestriction_viewport, _GeometryRestriction_geometryMathManager, _GeometryRestriction_nodes, _GeometryRestriction_settings, _GeometryRestriction_snapRestrictions, _GeometryRestriction_snapToEdges, _GeometryRestriction_snapToFaces, _GeometryRestriction_snapToVertices, _GeometryRestriction_visualizationObject, _GeometryRestriction_wireframe, _GeometryRestriction_wireframeColor;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeometryRestriction = void 0;
const THREE = __importStar(require("three"));
const AbstractRestriction_1 = require("../AbstractRestriction");
const gl_matrix_1 = require("gl-matrix");
// #endregion Type aliases (1)
// #region Classes (1)
class GeometryRestriction extends AbstractRestriction_1.AbstractRestriction {
    // #endregion Properties (10)
    // #region Constructors (1)
    constructor(drawingToolsManager, id, properties) {
        var _a, _b;
        super(drawingToolsManager, id);
        // #region Properties (10)
        _GeometryRestriction_raycaster.set(this, new THREE.Raycaster());
        _GeometryRestriction_viewport.set(this, void 0);
        _GeometryRestriction_geometryMathManager.set(this, void 0);
        _GeometryRestriction_nodes.set(this, []);
        _GeometryRestriction_settings.set(this, void 0);
        _GeometryRestriction_snapRestrictions.set(this, {});
        _GeometryRestriction_snapToEdges.set(this, true);
        _GeometryRestriction_snapToFaces.set(this, true);
        _GeometryRestriction_snapToVertices.set(this, true);
        _GeometryRestriction_visualizationObject.set(this, new THREE.Object3D());
        _GeometryRestriction_wireframe.set(this, void 0);
        _GeometryRestriction_wireframeColor.set(this, void 0);
        __classPrivateFieldSet(this, _GeometryRestriction_viewport, drawingToolsManager.viewport, "f");
        __classPrivateFieldSet(this, _GeometryRestriction_settings, drawingToolsManager.settings, "f");
        __classPrivateFieldSet(this, _GeometryRestriction_geometryMathManager, drawingToolsManager.geometryMathManager, "f");
        __classPrivateFieldSet(this, _GeometryRestriction_wireframe, (_a = properties.wireframe) !== null && _a !== void 0 ? _a : true, "f");
        __classPrivateFieldSet(this, _GeometryRestriction_wireframeColor, (_b = properties.wireframeColor) !== null && _b !== void 0 ? _b : __classPrivateFieldGet(this, _GeometryRestriction_settings, "f").visualization.points.color_1, "f");
        this.updateNodes(properties.nodes);
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (8)
    get priority() {
        return 0;
    }
    get snapRestrictions() {
        return __classPrivateFieldGet(this, _GeometryRestriction_snapRestrictions, "f");
    }
    get snapToEdges() {
        return __classPrivateFieldGet(this, _GeometryRestriction_snapToEdges, "f");
    }
    set snapToEdges(value) {
        __classPrivateFieldSet(this, _GeometryRestriction_snapToEdges, value, "f");
    }
    get snapToFaces() {
        return __classPrivateFieldGet(this, _GeometryRestriction_snapToFaces, "f");
    }
    set snapToFaces(value) {
        __classPrivateFieldSet(this, _GeometryRestriction_snapToFaces, value, "f");
    }
    get snapToVertices() {
        return __classPrivateFieldGet(this, _GeometryRestriction_snapToVertices, "f");
    }
    set snapToVertices(value) {
        __classPrivateFieldSet(this, _GeometryRestriction_snapToVertices, value, "f");
    }
    // #endregion Public Getters And Setters (8)
    // #region Public Methods (2)
    rayTrace(ray, metaData) {
        if (this.enabled === false)
            return;
        if (__classPrivateFieldGet(this, _GeometryRestriction_snapToVertices, "f") === false && __classPrivateFieldGet(this, _GeometryRestriction_snapToEdges, "f") === false && __classPrivateFieldGet(this, _GeometryRestriction_snapToFaces, "f") === false)
            return;
        __classPrivateFieldGet(this, _GeometryRestriction_raycaster, "f").ray.direction.set(ray.direction[0], ray.direction[1], ray.direction[2]);
        __classPrivateFieldGet(this, _GeometryRestriction_raycaster, "f").ray.origin.set(ray.origin[0], ray.origin[1], ray.origin[2]);
        // intersect all nodes
        let intersections = [];
        __classPrivateFieldGet(this, _GeometryRestriction_nodes, "f").forEach(node => {
            const threeJsObject = node.convertedObject[__classPrivateFieldGet(this, _GeometryRestriction_viewport, "f").id];
            if (threeJsObject) {
                const currentIntersections = __classPrivateFieldGet(this, _GeometryRestriction_raycaster, "f").intersectObject(threeJsObject);
                intersections = intersections.concat(currentIntersections);
            }
        });
        // sort
        intersections.sort((a, b) => a.distance - b.distance);
        // return first intersection
        if (intersections.length > 0) {
            const object = intersections[0].object;
            const geometry = object.geometry;
            const positionAttribute = geometry.getAttribute('position');
            const intersectionPoint = intersections[0].point;
            const intersectionPointVec3 = gl_matrix_1.vec3.fromValues(intersectionPoint.x, intersectionPoint.y, intersectionPoint.z);
            if (!intersections[0].face)
                return gl_matrix_1.vec3.fromValues(intersectionPoint.x, intersectionPoint.y, intersectionPoint.z);
            if (__classPrivateFieldGet(this, _GeometryRestriction_snapToVertices, "f") === true || __classPrivateFieldGet(this, _GeometryRestriction_snapToEdges, "f") === true) {
                const vertexA = new THREE.Vector3();
                vertexA.fromBufferAttribute(positionAttribute, intersections[0].face.a);
                object.localToWorld(vertexA);
                const vertexAVec3 = gl_matrix_1.vec3.fromValues(vertexA.x, vertexA.y, vertexA.z);
                const vertexB = new THREE.Vector3();
                vertexB.fromBufferAttribute(positionAttribute, intersections[0].face.b);
                object.localToWorld(vertexB);
                const vertexBVec3 = gl_matrix_1.vec3.fromValues(vertexB.x, vertexB.y, vertexB.z);
                const vertexC = new THREE.Vector3();
                vertexC.fromBufferAttribute(positionAttribute, intersections[0].face.c);
                object.localToWorld(vertexC);
                const vertexCVec3 = gl_matrix_1.vec3.fromValues(vertexC.x, vertexC.y, vertexC.z);
                if (__classPrivateFieldGet(this, _GeometryRestriction_snapToVertices, "f") === true) {
                    const distanceA = __classPrivateFieldGet(this, _GeometryRestriction_geometryMathManager, "f").screenSpaceDistanceCheck(intersectionPointVec3, vertexAVec3, __classPrivateFieldGet(this, _GeometryRestriction_settings, "f").visualization.points.size_0 * __classPrivateFieldGet(this, _GeometryRestriction_settings, "f").visualization.distanceMultiplicationFactor);
                    const distanceB = __classPrivateFieldGet(this, _GeometryRestriction_geometryMathManager, "f").screenSpaceDistanceCheck(intersectionPointVec3, vertexBVec3, __classPrivateFieldGet(this, _GeometryRestriction_settings, "f").visualization.points.size_0 * __classPrivateFieldGet(this, _GeometryRestriction_settings, "f").visualization.distanceMultiplicationFactor);
                    const distanceC = __classPrivateFieldGet(this, _GeometryRestriction_geometryMathManager, "f").screenSpaceDistanceCheck(intersectionPointVec3, vertexCVec3, __classPrivateFieldGet(this, _GeometryRestriction_settings, "f").visualization.points.size_0 * __classPrivateFieldGet(this, _GeometryRestriction_settings, "f").visualization.distanceMultiplicationFactor);
                    // part 1 - check if the intersection point is close to a vertex
                    if (distanceA.check && distanceA.distanceSquared < distanceB.distanceSquared && distanceA.distanceSquared < distanceC.distanceSquared) {
                        return gl_matrix_1.vec3.fromValues(vertexA.x, vertexA.y, vertexA.z);
                    }
                    else if (distanceB.check && distanceB.distanceSquared < distanceA.distanceSquared && distanceB.distanceSquared < distanceC.distanceSquared) {
                        return gl_matrix_1.vec3.fromValues(vertexB.x, vertexB.y, vertexB.z);
                    }
                    else if (distanceC.check && distanceC.distanceSquared < distanceA.distanceSquared && distanceC.distanceSquared < distanceB.distanceSquared) {
                        return gl_matrix_1.vec3.fromValues(vertexC.x, vertexC.y, vertexC.z);
                    }
                }
                if (__classPrivateFieldGet(this, _GeometryRestriction_snapToEdges, "f") === true) {
                    // part 2 - check if the intersection point is close to an edge
                    // create the closest points on the edges
                    const closestPointOnEdgeAB = __classPrivateFieldGet(this, _GeometryRestriction_geometryMathManager, "f").closestPointOnLine(vertexAVec3, vertexBVec3, intersectionPointVec3);
                    const closestPointOnEdgeBC = __classPrivateFieldGet(this, _GeometryRestriction_geometryMathManager, "f").closestPointOnLine(vertexBVec3, vertexCVec3, intersectionPointVec3);
                    const closestPointOnEdgeCA = __classPrivateFieldGet(this, _GeometryRestriction_geometryMathManager, "f").closestPointOnLine(vertexCVec3, vertexAVec3, intersectionPointVec3);
                    // create the distances
                    const distanceAB = __classPrivateFieldGet(this, _GeometryRestriction_geometryMathManager, "f").screenSpaceDistanceCheck(intersectionPointVec3, closestPointOnEdgeAB, __classPrivateFieldGet(this, _GeometryRestriction_settings, "f").visualization.points.size_0 * __classPrivateFieldGet(this, _GeometryRestriction_settings, "f").visualization.distanceMultiplicationFactor);
                    const distanceBC = __classPrivateFieldGet(this, _GeometryRestriction_geometryMathManager, "f").screenSpaceDistanceCheck(intersectionPointVec3, closestPointOnEdgeBC, __classPrivateFieldGet(this, _GeometryRestriction_settings, "f").visualization.points.size_0 * __classPrivateFieldGet(this, _GeometryRestriction_settings, "f").visualization.distanceMultiplicationFactor);
                    const distanceCA = __classPrivateFieldGet(this, _GeometryRestriction_geometryMathManager, "f").screenSpaceDistanceCheck(intersectionPointVec3, closestPointOnEdgeCA, __classPrivateFieldGet(this, _GeometryRestriction_settings, "f").visualization.points.size_0 * __classPrivateFieldGet(this, _GeometryRestriction_settings, "f").visualization.distanceMultiplicationFactor);
                    // check if the intersection point is close to an edge
                    if (distanceAB.check && distanceAB.distanceSquared < distanceBC.distanceSquared && distanceAB.distanceSquared < distanceCA.distanceSquared) {
                        return closestPointOnEdgeAB;
                    }
                    else if (distanceBC.check && distanceBC.distanceSquared < distanceAB.distanceSquared && distanceBC.distanceSquared < distanceCA.distanceSquared) {
                        return closestPointOnEdgeBC;
                    }
                    else if (distanceCA.check && distanceCA.distanceSquared < distanceAB.distanceSquared && distanceCA.distanceSquared < distanceBC.distanceSquared) {
                        return closestPointOnEdgeCA;
                    }
                }
            }
            if (__classPrivateFieldGet(this, _GeometryRestriction_snapToFaces, "f") === true) {
                // part 3 - face intersection
                return gl_matrix_1.vec3.fromValues(intersectionPoint.x, intersectionPoint.y, intersectionPoint.z);
            }
        }
        return;
    }
    updateNodes(nodes) {
        __classPrivateFieldSet(this, _GeometryRestriction_nodes, nodes, "f");
        if (__classPrivateFieldGet(this, _GeometryRestriction_wireframe, "f")) {
            __classPrivateFieldGet(this, _GeometryRestriction_visualizationObject, "f").traverse((object) => {
                if (object instanceof THREE.LineSegments) {
                    object.geometry.dispose();
                    object.material.dispose();
                }
            });
            this._object3D.remove(__classPrivateFieldGet(this, _GeometryRestriction_visualizationObject, "f"));
            __classPrivateFieldSet(this, _GeometryRestriction_visualizationObject, new THREE.Object3D(), "f");
            __classPrivateFieldGet(this, _GeometryRestriction_nodes, "f").forEach(node => {
                const threeJsObject = node.convertedObject[__classPrivateFieldGet(this, _GeometryRestriction_viewport, "f").id];
                if (threeJsObject) {
                    threeJsObject.traverse((object) => {
                        if (object instanceof THREE.Mesh) {
                            const wireframe = new THREE.WireframeGeometry(object.geometry);
                            const line = new THREE.LineSegments(wireframe, new THREE.LineBasicMaterial({ color: new THREE.Color(__classPrivateFieldGet(this, _GeometryRestriction_wireframeColor, "f")) }));
                            __classPrivateFieldGet(this, _GeometryRestriction_visualizationObject, "f").add(line);
                        }
                    });
                }
            });
            this._object3D.add(__classPrivateFieldGet(this, _GeometryRestriction_visualizationObject, "f"));
        }
    }
    // #endregion Public Methods (2)
    // #region Protected Methods (1)
    visibilityChanged() { }
}
exports.GeometryRestriction = GeometryRestriction;
_GeometryRestriction_raycaster = new WeakMap(), _GeometryRestriction_viewport = new WeakMap(), _GeometryRestriction_geometryMathManager = new WeakMap(), _GeometryRestriction_nodes = new WeakMap(), _GeometryRestriction_settings = new WeakMap(), _GeometryRestriction_snapRestrictions = new WeakMap(), _GeometryRestriction_snapToEdges = new WeakMap(), _GeometryRestriction_snapToFaces = new WeakMap(), _GeometryRestriction_snapToVertices = new WeakMap(), _GeometryRestriction_visualizationObject = new WeakMap(), _GeometryRestriction_wireframe = new WeakMap(), _GeometryRestriction_wireframeColor = new WeakMap();
// #endregion Classes (1)
//# sourceMappingURL=GeometryRestriction.js.map